import { CapoPlugin } from "/vercel/path0/node_modules/.pnpm/@unhead+vue@1.9.15_vue@3.4.31_typescript@5.5.3_/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];